import { render } from "./WorkflowDesigner.vue?vue&type=template&id=7984dfbe"
import script from "./WorkflowDesigner.vue?vue&type=script&lang=js"
export * from "./WorkflowDesigner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/flow/workflow-designer/WorkflowDesigner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7984dfbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7984dfbe', __exports__)) {
    api.reload('7984dfbe', __exports__)
  }
  
  module.hot.accept("./WorkflowDesigner.vue?vue&type=template&id=7984dfbe", () => {
    api.rerender('7984dfbe', render)
  })

}


export default __exports__